<template>
  <div class="set-birthday">
    <p class="who">你的生日</p>
    <div class="choose-con">
      <van-datetime-picker
        v-if="datepicker.currentDate"
        v-model="datepicker.currentDate"
        type="date"
        :min-date="datepicker.minDate"
        :max-date="datepicker.maxDate"
        :visible-item-count="3"
        :formatter="formatter"
        :default-index="dateDefaultIndex"
        @change="birthdayChange"
      />
      <p class="select-date-tip">上下滑动选择日期</p>
      <p class="cautious">选择后不可更改哦，请谨慎选择</p>
      <a class="content-btn selected" href="javascript:;" @click="selectItem(datepicker.currentDate)">下一步</a>
    </div>
  </div>
</template>

<script>
import { setCookie, getCookie } from '@/utils/tools'
export default {
  data () {
    return {
      datepicker: {
        minDate: new Date(1919, 1, 1),
        maxDate: new Date(),
        currentDate: null
      },
      dateDefaultIndex: new Date().getFullYear() - 1919
    }
  },
  methods: {
    formatter (type, value) {
      if (type === 'year') {
        return `${value}年`
      } else if (type === 'month') {
        return `${value}月`
      } else if (type === 'day') {
        return `${value}日`
      }
      return value
    },
    birthdayChange () {
      setCookie('birthday', this.datepicker.currentDate)
    },
    selectItem (val) {
      if (!val) return
      setCookie('birthday', val)
      this.$router.push({
        name: 'SetTall'
      })
    }
  },
  mounted () {
    let birthday = getCookie('birthday')
    console.log(this.datepicker.currentDate)
    if (birthday) {
      this.datepicker.currentDate = new Date(birthday)
    } else {
      this.datepicker.currentDate = new Date()
    }
    this.$forceUpdate()
  }
}
</script>
